"use strict";
/**
 * @packageDocumentation
 * @module harmony-account
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=types.js.map